import Drawer from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';

export const FormDrawerStyled = styled(Drawer)`
  .form_drawer_container {
    height: calc(100vh - 80px) !important;
    overflow-y: auto !important;
    background-color: ${({ theme }) => theme.custom.background.main};

    .title {
      font-size: 24px;
      font-weight: 600;
      color: ${({ theme }) => theme.custom.primary.dark};
    }

    &.active {
      height: 100vh !important;
    }
    
    &::-webkit-scrollbar {
      width: 12px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.custom.scrollbar.thumb};
      border-radius: 12px;
    }
    &::-webkit-scrollbar-track {
      background-color: ${({ theme }) => theme.custom.scrollbar.track};
      border-radius: 12px;
    }

    .form_drawer_header {
      width: 100%;
      padding: 34px 24px 24px 24px;
      background-color: ${({ theme }) => theme.custom.background.main};
      border-bottom: 1px solid ${({ theme }) => theme.custom.border.light};

      .form_drawer_header_content {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }

    .form_drawer_content {
      height: calc(100vh - 98px - 80px) !important;
      padding: 0 24px;
      background-color: ${({ theme }) => theme.custom.background.main};
    }
  }

  .form_drawer_bottom {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.custom.background.main} !important;
    border-top: 1px solid ${({ theme }) => theme.custom.border.light};
    
    .form_drawer_bottom_content {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 24px;
      gap: 12px;
    }
  }
    
  .deleteBtn {
    background-color: ${({ theme }) => theme.palette.error.main} !important;
    color: ${({ theme }) => theme.palette.error.contrastText} !important;
    border: 1px solid ${({ theme }) => theme.palette.error.main} !important;
    
    &:hover {
      background-color: ${({ theme }) => theme.palette.error.dark} !important;
      border-color: ${({ theme }) => theme.palette.error.dark} !important;
    }
  }
  
  .saveBtn {
    background-color: ${({ theme }) => theme.palette.primary.main} !important;
    color: ${({ theme }) => theme.palette.primary.contrastText} !important;
    border: 1px solid ${({ theme }) => theme.palette.primary.main} !important;
    
    &:hover {
      background-color: ${({ theme }) => theme.palette.primary.dark} !important;
      border-color: ${({ theme }) => theme.palette.primary.dark} !important;
    }
  }
  
  .cancelBtn {
    background-color: transparent !important;
    color: ${({ theme }) => theme.palette.text.secondary} !important;
    border: 1px solid ${({ theme }) => theme.custom.border.main} !important;
    
    &:hover {
      background-color: ${({ theme }) => theme.custom.background.secondary} !important;
      border-color: ${({ theme }) => theme.custom.border.dark} !important;
    }
  }
`;
